import { printerProofService } from '../../helpers/services/printerProof.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRINTER_PFOOF_MODULE = 'printerProofStatus'; 

// define action 
export const GET_ALL_PRINTER_PROOFS = 'getAllPrinterProofs';
export const GET_PRINTER_PROOF = 'getPrinterProof';
export const UPDATE_PRINTER_PROOF = 'updatePrinterProof';
export const CREATE_PRINTER_PROOF = 'createPrinterProof';
export const UPDATE_PRINTER_PROOF_STATUS = 'updatePrinterProofStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRINTER_PROOFS_REQUEST = "getAllPrinterProofs";
const GET_PRINTER_PROOF_REQUEST = "getPrinterProof";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_PRINTER_PROOFS]({ commit }, { filter }) {
        printerProofService
            .getAllPrinterProofs(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRINTER_PROOFS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    async [GET_PRINTER_PROOF]({ commit }, { id }) {
       await printerProofService
            .getPrinterProof(id)
            .then(
                (result) => {
                    commit(GET_PRINTER_PROOF_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRINTER_PROOF]({ commit }, { data }) {
        commit(REQUEST)
        printerProofService
            .updatePrinterProof(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.printerProof')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRINTER_PROOF]({ commit }, { data }) {
        commit(REQUEST)
        printerProofService
            .createPrinterProof(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.printerProof')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRINTER_PROOF_STATUS]({ dispatch }, { filter, data }) {
        printerProofService
            .updatePrinterProofStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRINTER_PROOFS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Printer-proof-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRINTER_PROOFS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRINTER_PROOF_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }


    }
}


